import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="platform-stripe-config"
export default class extends Controller {
  static targets = [
    "secretInput",
    "webhookInput",
    "secretButton",
    "webhookButton"
  ]

  toggleSecret() {
    if (!this.hasSecretInputTarget || !this.hasSecretButtonTarget) return
    this.toggleInputType(this.secretInputTarget, this.secretButtonTarget)
  }

  toggleWebhook() {
    if (!this.hasWebhookInputTarget || !this.hasWebhookButtonTarget) return
    this.toggleInputType(this.webhookInputTarget, this.webhookButtonTarget)
  }

  toggleInputType(input, button) {
    const hidden = input.type === "password"
    input.type = hidden ? "text" : "password"
    button.textContent = hidden ? "Hide" : "Show"
  }
}
